import React from "react";

const Outcomes = ({ outcomes }) => {
  return (
    <div className="relative">
      <div className="max-w-6xl mx-auto h-full">
        <div className="absolute inset-0">
          <img
            src="/image-fix/random-images/r17.jpg"
            alt="Outcomes background"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 md:p-10 p-3 space-y-5">
          <div>
            <p className="text-white font-bold text-lg md:text-xl ">
              Expected Outcomes
            </p>
          </div>
          <div className="bg-sdbodywhite h-0.5 w-10"></div>
          <div className="space-y-4">
            {outcomes &&
              outcomes.map((outcome, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <div className="w-6 h-6">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="text-white"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <div>
                    <p className="text-white text-sm md:text-base">{outcome}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Outcomes;
